const DeveloperBoard = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M166.5-129q-30.94 0-52.97-22.03Q91.5-173.06 91.5-204v-552q0-30.94 22.03-52.97Q135.56-831 166.5-831h552q30.94 0 52.97 22.03Q793.5-786.94 793.5-756v75h75v75h-75v88.5h75v75h-75v88.5h75v75h-75v75q0 30.94-22.03 52.97Q749.44-129 718.5-129h-552Zm0-75h552v-552h-552v552Zm75-75h203v-162h-203v162ZM482-560.5h161.5V-681H482v120.5Zm-240.5 82h203V-681h-203v202.5ZM482-279h161.5v-244H482v244ZM166.5-756v552-552Z"></path>
        </svg>
    )
}

export default DeveloperBoard;